import RuleTesterModal from "./Modal";

export default RuleTesterModal;
